import ICertificateExpireTimeSpanVm from "./../shared/ICertificateExpireTimeSpanVm"
import ICountryVm from "./../shared/ICountryVm"
import IDeclarationOfficeVm from "./../shared/IDeclarationOfficeVm"
import IEducationalInstitutionVm from "./../shared/IEducationalInstitutionVm"
import IMunicipalityVm from "./../shared/IMunicipalityVm"
import IPostalCodeVm from "./../shared/IPostalCodeVm"
import IUserVm from "./../shared/IUserVm"
import IContextBaseVm from "./../home/Shared/IContextBaseVm"

import * as IContextBaseVmInstance from "./../home/Shared/IContextBaseVm"
import * as IUserVmInstance from "./../shared/IUserVm"

export default interface ICaseworkerContextVm extends IContextBaseVm {
    name: string
    caseworkerId: string
    companyRegistrationIdentifier: string
    user: IUserVm
    educationalInstitutions: IEducationalInstitutionVm[]
    countries: ICountryVm[]
    postalCodes: IPostalCodeVm[]
    certificateExpireTimeSpans: ICertificateExpireTimeSpanVm[]
    municipalities: IMunicipalityVm[]
    declarationOffices: IDeclarationOfficeVm[]
    todaysPriceForReplacementApplication: number
}

export const empty = (enableIteration: boolean = true): ICaseworkerContextVm => {
	return {
		...IContextBaseVmInstance.empty(),
		name: "",
		caseworkerId: "",
		companyRegistrationIdentifier: "",
		user: IUserVmInstance.empty(),
		educationalInstitutions: [] as IEducationalInstitutionVm[],
		countries: [] as ICountryVm[],
		postalCodes: [] as IPostalCodeVm[],
		certificateExpireTimeSpans: [] as ICertificateExpireTimeSpanVm[],
		municipalities: [] as IMunicipalityVm[],
		declarationOffices: [] as IDeclarationOfficeVm[],
		todaysPriceForReplacementApplication: -1
	} as ICaseworkerContextVm
}